export  default {
    methods:{
        initPageInfo: function initPageInfo() {
            let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.$set(this, 'page', {
                list: response.content || [],
                pageNum: response.number+1 || 0,
                pageSize: response.size || 10,
                total: response.totalElements || 0
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/warp/support/pager.js